'use strict';

bbw.shared.ShowModalTrait = {

    _showModal: function(action, scope, init) {
        var deferred = this.$q.defer();
        var $scope = this.$scope.$new();
        angular.extend($scope, scope || {});
        this.$fancyModal.open({
            templateUrl: bbw.templateUrl(action + '.html'),
            scope: $scope,
            controller: ['$scope', function($scope) {
                if (angular.isFunction(init)) {
                    init($scope);
                }
                $scope.ok = function(value) {
                    deferred.resolve(value);
                    $scope.$modal.close();
                };
                $scope.cancel = function() {
                    deferred.reject();
                    $scope.$modal.close();
                };
            }]
        });
        return deferred.promise;
    }

};
